import React, { useRef, useEffect } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  CardActions,
  Button,
  Typography,
} from "@material-ui/core";
import { useStyles } from "./style";
import classNames from "classnames";
import { useActiveArticle } from "../../../../Contexts/ActiveArticleContext";

const NewsCard = ({ article, index }) => {
  const classes = useStyles();
  const cardRef = useRef();
  const [activeArticle, setActiveArticle] = useActiveArticle();

  useEffect(() => {
    if (activeArticle === index) {
      window.scroll(0, cardRef.current.offsetTop - 50);
    }
  }, [activeArticle]);

  return (
    <Card
      ref={cardRef}
      className={classNames(
        classes.card,
        index === activeArticle ? classes.active : null
      )}
    >
      <CardActionArea href={article.url} target="_blank">
        <CardMedia
          image={
            article.urlToImage ||
            "https://media.istockphoto.com/vectors/male-hand-holding-megaphone-with-breaking-news-speech-bubble-banner-vector-id1197831888?k=6&m=1197831888&s=612x612&w=0&h=VJvkLPJQ3k3xhN16Y-g7dAGqxmWOHfPkteHwtjYlTSc="
          }
          className={classes.media}
        />

        <div className={classes.extras}>
          <Typography variant="body2" component="h2" color="textSecondary">
            {article.source.name ? article.source.name : "Anonymous"}
          </Typography>
          <Typography variant="body2" component="h2" color="textSecondary">
            {new Date(article.publishedAt).toDateString()}
          </Typography>
        </div>

        <Typography variant="h5" gutterBottom className={classes.title}>
          {article.title}
        </Typography>

        <CardContent>
          <Typography variant="body2" component="h2" color="textSecondary">
            {article.description}
          </Typography>
        </CardContent>
      </CardActionArea>

      <CardActions className={classes.footer}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          href={article.url}
          target="_blank"
        >
          {" "}
          Learn More
        </Button>
        <Typography variant="h5" component="h1" color="textSecondary">
          {index + 1}
        </Typography>
      </CardActions>
    </Card>
  );
};

export default NewsCard;
